export default __webpack_public_path__ + "static/media/apsLogo.809ff9ef.png";